import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  getAccessProfileUsersRequest: ['ramal'],
  getAccessProfileUsersFailure: [],
  getAccessProfileUsersSuccess: ['data', 'total', 'ramal'],
  setAccessProfileSort: ['sort', 'direction', 'ramal'],
  setAccessProfilePage: ['page', 'limit', 'ramal'],
  setAccessProfileSearch: ['value', 'ramal'],
  setAccessProfilePropertyFilter: ['property', 'value', 'ramal'],
  getAccessProfileFilterRolesRequest: [],
  getAccessProfileFilterRolesSuccess: ['data'],
  getAccessProfileFilterRolesFailure: [],
  resetAccessProfile: [],
  resetAccessProfileFilters: [],
  setChangeShowHideColumnsAccessProfile: ['newTableColumns'],
})

const INITIAL_STATE = {
  options: {
    sort: 'name',
    direction: 'asc',
    search: '',
    page: 0,
    total: 0,
    limit: 20,
    filters: [
      {
        name: 'role_id',
        value: null,
      },
    ],
  },
  data: [],
  loading: false,
  roles: {
    data: [],
    loading: false,
  },
  showHideColumns: {
    name: true,
    function: true,
    department: true,
    dealership: true,
    active: false,
    lastLogin: false,
  },
}

const resetAccessProfileFilters = () => ({
  ...INITIAL_STATE,
})

const setAccessProfilePropertyFilter = (state = INITIAL_STATE, { property, value }) => {
  return {
    ...state,
    options: {
      ...state.options,
      filters: state.options.filters.map((filter) => {
        if (filter.name === property) {
          return {
            ...filter,
            value,
          }
        }
        return filter
      }),
    },
  }
}

const getAccessProfileFilterRolesRequest = (state = INITIAL_STATE) => ({
  ...state,
  roles: {
    ...state.roles,
    loading: true,
  },
})
const getAccessProfileFilterRolesSuccess = (state = INITIAL_STATE, { data }) => ({
  ...state,
  roles: {
    ...state.roles,
    data,
    loading: false,
  },
})
const getAccessProfileFilterRolesFailure = (state = INITIAL_STATE) => ({
  ...state,
  roles: {
    ...state.roles,
    loading: false,
  },
})

const getAccessProfileUsersRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})
const getAccessProfileUsersFailure = (state = INITIAL_STATE) => ({
  ...state,
  data: [],
  loading: false,
})
const getAccessProfileUsersSuccess = (state = INITIAL_STATE, { data, total }) => ({
  ...state,
  options: {
    ...state.options,
    total,
  },
  data,
  loading: false,
})

const setAccessProfileSort = (state = INITIAL_STATE, { sort, direction }) => ({
  ...state,
  options: {
    ...state.options,
    sort,
    direction,
    page: 0,
  },
})

const setAccessProfilePage = (state = INITIAL_STATE, { page, limit }) => ({
  ...state,
  options: {
    ...state.options,
    page,
    limit,
  },
})

const setAccessProfileSearch = (state = INITIAL_STATE, { value }) => ({
  ...state,
  options: {
    ...state.options,
    search: value,
    page: 0,
  },
})

const resetAccessProfile = () => ({
  ...INITIAL_STATE,
})

const setChangeShowHideColumnsAccessProfile = (
  state = INITIAL_STATE,
  { newTableColumns },
) => {
  localStorage.setItem(
    'caid.columnsTableUsers',
    JSON.stringify(newTableColumns),
  )
  return {
    ...state,
    showHideColumns: newTableColumns,
  }
}

export default createReducer(INITIAL_STATE, {
  [Types.GET_ACCESS_PROFILE_FILTER_ROLES_REQUEST]: getAccessProfileFilterRolesRequest,
  [Types.GET_ACCESS_PROFILE_FILTER_ROLES_FAILURE]: getAccessProfileFilterRolesFailure,
  [Types.GET_ACCESS_PROFILE_FILTER_ROLES_SUCCESS]: getAccessProfileFilterRolesSuccess,
  [Types.GET_ACCESS_PROFILE_USERS_REQUEST]: getAccessProfileUsersRequest,
  [Types.GET_ACCESS_PROFILE_USERS_FAILURE]: getAccessProfileUsersFailure,
  [Types.GET_ACCESS_PROFILE_USERS_SUCCESS]: getAccessProfileUsersSuccess,
  [Types.RESET_ACCESS_PROFILE_FILTERS]: resetAccessProfileFilters,
  [Types.RESET_ACCESS_PROFILE]: resetAccessProfile,
  [Types.SET_CHANGE_SHOW_HIDE_COLUMNS_ACCESS_PROFILE]: setChangeShowHideColumnsAccessProfile,
  [Types.SET_ACCESS_PROFILE_PAGE]: setAccessProfilePage,
  [Types.SET_ACCESS_PROFILE_PROPERTY_FILTER]: setAccessProfilePropertyFilter,
  [Types.SET_ACCESS_PROFILE_SEARCH]: setAccessProfileSearch,
  [Types.SET_ACCESS_PROFILE_SORT]: setAccessProfileSort,
})
